import { createSlice } from "@reduxjs/toolkit";
import { getCookie } from "../../cookies/cookies";
import { RootState } from "../store";

export interface LegalState {
  acceptedTermsOfService: boolean;
  confirm: boolean;
}

export const LegalCookieName = "acceptedTermsOfService";

// Retrieve if acceptance of terms of service was stored as a cookie
export function getAcceptedTermsOfServiceCookie() {
  return getCookie(LegalCookieName) === "true";
}

const initialState: LegalState = {
  acceptedTermsOfService: getAcceptedTermsOfServiceCookie(),
  confirm: false,
};

export const legalSlice = createSlice({
  name: "legal",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    acceptTermsOfService: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.acceptedTermsOfService = true;
    },
    toggleAcceptance: (state) => {
      state.confirm = !state.confirm;
    },
  },
});

export const { acceptTermsOfService, toggleAcceptance } = legalSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectAcceptedTermsOfService = (state: RootState) =>
  state.legal.acceptedTermsOfService;

export const selectConfirm = (state: RootState) => state.legal.confirm;

export default legalSlice.reducer;
